// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { 
//   getConductors, 
//   getConductorById, 
//   updateConductor,
//   getPendingConductors,
//   approvePendingConductor,
//   rejectPendingConductor,
//   getPendingConductorById,
//   updatePendingConductor 
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Mobile</th>
//           <th>Bus Owner</th>
//           <th>Assigned Bus</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-profile-image"></div>
//         <div className="details-grid">
//           {[1, 2, 3, 4, 5, 6].map((i) => (
//             <div key={i} className="detail-section">
//               <div className="skeleton-label"></div>
//               <div className="skeleton-value"></div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonEditModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 edit-modal skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const ConductorManagement = () => {
//   const { token } = useSelector(state => state.user);
  
//   const [conductors, setConductors] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  
//   const [viewMode, setViewMode] = useState('regular');
//   const [pendingConductors, setPendingConductors] = useState([]);
//   const [loadingPending, setLoadingPending] = useState(false);
  
//   const [editingConductor, setEditingConductor] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingConductor, setViewingConductor] = useState(null);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalConductors, setTotalConductors] = useState(0);
//   const [pageSize] = useState(10);

//   const [isEditingPending, setIsEditingPending] = useState(false);

//   // ✅ Ref for debounce timeout
//   const searchTimeoutRef = useRef(null);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   // ✅ FIXED: fetchConductors with debounced search term
//   const fetchConductors = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);
      
//       const response = await getConductors(token, currentPage, pageSize, debouncedSearchTerm);

//       if (response && response.conductors) {
//         const transformedConductors = response.conductors.map((conductor, index) => ({
//           id: conductor._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: conductor.profileImage,
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',
//           assignedBus: conductor.assignedBus || null,
//           busOwner: conductor.busOwner || null,
//           isActive: conductor.isActive || false,
//           joined: new Date(conductor.createdAt).toISOString().split('T')[0],
//           status: conductor.isActive ? 'Active' : 'Inactive',
//           isPending: false,
//           source: 'regular'
//         }));

//         setConductors(transformedConductors);
//         setTotalPages(response.totalPages || 1);
//         setTotalConductors(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch conductors.');
//       console.error('Error fetching conductors:', err);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const fetchPendingConductors = async () => {
//     try {
//       setLoadingPending(true);
//       setError(null);

//       const response = await getPendingConductors(token);

//       if (response && response.success) {
//         const transformedConductors = response.data.map((conductor, index) => ({
//           id: conductor._id,
//           pendingId: conductor._id,
//           serialNo: index + 1,
//           profileImage: conductor.profileImage || '',
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',
//           assignedBus: conductor.assignedBus || null,
//           busOwner: conductor.busOwner || null,
//           isActive: false,
//           joined: new Date(conductor.createdAt).toISOString().split('T')[0],
//           status: 'Pending',
//           isPending: true,
//           source: 'pending',
//           submittedBy: conductor.submittedBy,
//           submittedByName: conductor.submittedByName,
//           submittedByEmail: conductor.submittedByEmail,
//           operationType: conductor.operationType,
//           approvalStatus: conductor.approvalStatus,
//           originalData: conductor.originalData
//         }));

//         setPendingConductors(transformedConductors);
//         setTotalConductors(transformedConductors.length);
//         setTotalPages(1);
//       } else {
//         setPendingConductors([]);
//         setTotalConductors(0);
//         setTotalPages(1);
//       }
//     } catch (err) {
//       console.error('Error fetching pending conductors:', err);
//       setError('Failed to fetch pending conductors. Please try again.');
//       setPendingConductors([]);
//     } finally {
//       setLoadingPending(false);
//     }
//   };

//   // ✅ FIXED: Effect depends on debounced search term
//   useEffect(() => {
//     if (viewMode === 'regular') {
//       fetchConductors();
//     } else {
//       fetchPendingConductors();
//     }
//   }, [viewMode, currentPage, debouncedSearchTerm]);

//   // ✅ Cleanup timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, []);

//   const refreshPendingConductors = async () => {
//     await fetchPendingConductors();
//   };

//   const getCurrentConductors = () => {
//     return viewMode === 'regular' ? conductors : pendingConductors;
//   };

//   const getCurrentLoading = () => {
//     return viewMode === 'regular' ? loading : loadingPending;
//   };

//   const currentConductors = getCurrentConductors();
//   const isLoading = getCurrentLoading();

//   // ✅ FIXED: No client-side filtering - server already filters
//   const filteredConductors = currentConductors;

//   const handleApprovePendingConductor = async (pendingId) => {
//     try {
//       setError(null);
//       const response = await approvePendingConductor(pendingId, token);

//       if (response.success) {
//         toast.success('Pending conductor approved successfully!');
//         setPendingConductors(prev => prev.filter(conductor => conductor.id !== pendingId));
//         setTotalConductors(prev => prev - 1);
//         await fetchConductors();
//       } else {
//         throw new Error(response.message || 'Failed to approve pending conductor');
//       }
//     } catch (err) {
//       console.error('Error approving pending conductor:', err);
//       setError('Failed to approve pending conductor. Please try again.');
//       toast.error('Failed to approve pending conductor. Please try again.');
//     }
//   };

//   const handleRejectPendingConductor = async (pendingId) => {
//     if (!window.confirm('Are you sure you want to reject this pending conductor?')) return;

//     try {
//       setError(null);
//       const response = await rejectPendingConductor(pendingId, token);

//       if (response.success) {
//         toast.success('Pending conductor rejected successfully!');
//         setPendingConductors(prev => prev.filter(conductor => conductor.id !== pendingId));
//         setTotalConductors(prev => prev - 1);
//       } else {
//         throw new Error(response.message || 'Failed to reject pending conductor');
//       }
//     } catch (err) {
//       console.error('Error rejecting pending conductor:', err);
//       setError('Failed to reject pending conductor. Please try again.');
//       toast.error('Failed to reject pending conductor. Please try again.');
//     }
//   };

//   const handleViewConductor = async (conductor) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);

//       let response;
      
//       if (conductor.isPending) {
//         response = await getPendingConductorById(conductor.id, token);
//       } else {
//         response = await getConductorById(conductor.id, token);
//       }
      
//       if (response.success) {
//         const conductorData = response.data;
//         setViewingConductor({
//           id: conductorData._id,
//           name: conductorData.name || '',
//           mobileNumber: conductorData.mobileNumber || '',
//           isActive: conductorData.isActive,
//           assignedBus: conductorData.assignedBus || null,
//           busOwner: conductorData.busOwner || null,
//           profileImage: conductorData.profileImage,
//           createdAt: new Date(conductorData.createdAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           updatedAt: new Date(conductorData.updatedAt).toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'long',
//             day: 'numeric'
//           }),
//           isPending: conductor.isPending,
//           submittedBy: conductorData.submittedBy,
//           submittedByName: conductorData.submittedByName,
//           operationType: conductorData.operationType
//         });
//       } else {
//         setError('Failed to fetch conductor details.');
//       }
//     } catch (err) {
//       console.error('Error fetching conductor details:', err);
//       setError('Failed to fetch conductor details.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditConductor = async (conductorId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
      
//       const response = await getConductorById(conductorId, token);
      
//       if (response.success) {
//         const conductor = response.data;
//         setEditingConductor(conductor._id);
//         setEditForm({
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',
//           isActive: conductor.isActive || true
//         });
//       } else {
//         setError('Failed to fetch conductor details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching conductor details for editing:', err);
//       setError('Failed to fetch conductor details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditPendingConductor = async (conductorId) => {
//     try {
//       setIsFetchingDetails(true);
//       setError(null);
//       setIsEditingPending(true);

//       const response = await getPendingConductorById(conductorId, token);

//       if (response.success) {
//         const conductor = response.data;
//         setEditingConductor(conductor._id);
//         setEditForm({
//           name: conductor.name || '',
//           mobileNumber: conductor.mobileNumber || '',
//           isActive: false
//         });
//       } else {
//         setError('Failed to fetch pending conductor details for editing.');
//       }
//     } catch (err) {
//       console.error('Error fetching pending conductor details for editing:', err);
//       setError('Failed to fetch pending conductor details for editing.');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);
      
//       const updateData = {
//         name: editForm.name,
//         mobileNumber: editForm.mobileNumber,
//         ...(isEditingPending ? {} : { isActive: editForm.isActive })
//       };

//       const response = isEditingPending
//         ? await updatePendingConductor(editingConductor, updateData, token)
//         : await updateConductor(editingConductor, updateData, token);
      
//       if (response.success) {
//         if (isEditingPending) {
//           setPendingConductors(prevConductors =>
//             prevConductors.map(conductor =>
//               conductor.id === editingConductor ? {
//                 ...conductor,
//                 name: response.data.name,
//                 mobileNumber: response.data.mobileNumber,
//               } : conductor
//             )
//           );
//           toast.success('Pending conductor updated successfully!');
//         } else {
//           setConductors(prevConductors =>
//             prevConductors.map(conductor =>
//               conductor.id === editingConductor ? {
//                 ...conductor,
//                 name: response.data.name,
//                 mobileNumber: response.data.mobileNumber,
//                 status: response.data.isActive ? 'Active' : 'Inactive',
//                 isActive: response.data.isActive
//               } : conductor
//             )
//           );
//           alert('Conductor updated successfully!');
//         }

//         setEditingConductor(null);
//         setEditForm({});
//         setIsEditingPending(false);
//       } else {
//         setError(response.message || 'Failed to update conductor.');
//       }
//     } catch (err) {
//       console.error('Error updating conductor:', err);
//       setError(err.response?.data?.message || 'Failed to update conductor. Please try again.');
//       if (!isEditingPending) alert('Failed to update conductor. Please try again.');
//       else toast.error('Failed to update pending conductor. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingConductor(null);
//     setEditForm({});
//     setError(null);
//     setIsEditingPending(false);
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingConductor(null);
//   };

//   // ✅ FIXED: Debounced search with page reset
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     setCurrentPage(1);
    
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
    
//     searchTimeoutRef.current = setTimeout(() => {
//       setDebouncedSearchTerm(value);
//     }, 500);
//   };

//   // ✅ FIXED: handleRefresh clears everything
//   const handleRefresh = () => {
//     setSearchTerm('');
//     setDebouncedSearchTerm('');
//     setCurrentPage(1);
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
//     if (viewMode === 'regular') {
//       fetchConductors();
//     } else {
//       fetchPendingConductors();
//     }
//   };

//   const handleExportCSV = () => {
//     if (currentConductors.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
//     const csvData = currentConductors.map(conductor => [
//       conductor.serialNo,
//       conductor.id,
//       conductor.name || '',
//       conductor.mobileNumber || '',
//       conductor.busOwner?.name || 'N/A',
//       conductor.assignedBus?.busNumber || 'N/A',
//       conductor.status,
//       conductor.joined
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `conductors-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   if (isLoading) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Conductor Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search conductors by name, mobile, or bus owner..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>

//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       <div style={{ fontSize: '12px', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
//         {viewMode === 'regular' ? (
//           <>Page: {currentPage} | Total Pages: {totalPages} | Total Conductors: {totalConductors}</>
//         ) : (
//           <>Pending Conductors: {pendingConductors.length} | {loadingPending ? 'Loading...' : ''}</>
//         )}
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total {viewMode === 'regular' ? 'Conductors' : 'Pending Conductors'}</h3>
//           <p>{totalConductors}</p>
//           <span>{viewMode === 'regular' ? 'All registered conductors' : 'Awaiting approval'}</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Conductors</h3>
//           <p>{viewMode === 'regular' ? conductors.filter(c => c.status === 'Active').length : 0}</p>
//           <span>Active conductors</span>
//         </div>
//         <div className="stat-card">
//           <h3>With Assigned Bus</h3>
//           <p>{viewMode === 'regular' ? conductors.filter(c => c.assignedBus).length : 0}</p>
//           <span>Conductors with bus assignment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{filteredConductors.length}</p>
//           <span>conductors found</span>
//         </div>
//       </div>

//       <div className="view-toggle-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', margin: '0 15px' }}>
//         <button
//           className={`toggle-btn ${viewMode === 'regular' ? 'active' : ''}`}
//           onClick={() => {
//             setViewMode('regular');
//             setCurrentPage(1);
//             setSearchTerm('');
//             setDebouncedSearchTerm('');
//             if (searchTimeoutRef.current) {
//               clearTimeout(searchTimeoutRef.current);
//             }
//           }}
//           style={{
//             padding: '8px 20px',
//             borderRadius: '20px',
//             border: '2px solid #007bff',
//             backgroundColor: viewMode === 'regular' ? '#007bff' : 'transparent',
//             color: viewMode === 'regular' ? 'white' : '#007bff',
//             cursor: 'pointer',
//             fontWeight: '500',
//             transition: 'all 0.3s'
//           }}
//         >
//           👤 Regular
//         </button>
//         <button
//           className={`toggle-btn ${viewMode === 'pending' ? 'active' : ''}`}
//           onClick={() => {
//             setViewMode('pending');
//             setCurrentPage(1);
//             setSearchTerm('');
//             setDebouncedSearchTerm('');
//             if (searchTimeoutRef.current) {
//               clearTimeout(searchTimeoutRef.current);
//             }
//           }}
//           style={{
//             padding: '8px 20px',
//             borderRadius: '20px',
//             border: '2px solid #ff9800',
//             backgroundColor: viewMode === 'pending' ? '#ff9800' : 'transparent',
//             color: viewMode === 'pending' ? 'white' : '#ff9800',
//             cursor: 'pointer',
//             fontWeight: '500',
//             transition: 'all 0.3s',
//             position: 'relative'
//           }}
//         >
//           📋 Executive Submitted
//           {viewMode === 'pending' && pendingConductors.length > 0 && (
//             <span style={{
//               position: 'absolute',
//               top: '-8px',
//               right: '-8px',
//               backgroundColor: 'red',
//               color: 'white',
//               borderRadius: '50%',
//               width: '20px',
//               height: '20px',
//               fontSize: '10px',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold'
//             }}>
//               {pendingConductors.length}
//             </span>
//           )}
//         </button>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Name</th>
//               <th>Mobile</th>
//               <th>Bus Owner</th>
//               <th>Assigned Bus</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredConductors.length > 0 ? (
//               filteredConductors.map(conductor => (
//                 <tr key={conductor.id} className={conductor.isPending ? 'pending-row' : ''}>
//                   <td>{conductor.serialNo}</td>
//                   <td>
//                     {!conductor.isPending && editingConductor === conductor.id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Name"
//                       />
//                     ) : (
//                       <>
//                         {conductor.name || 'N/A'}
//                       </>
//                     )}
//                   </td>
//                   <td>
//                     {!conductor.isPending && editingConductor === conductor.id ? (
//                       <input
//                         type="text"
//                         name="mobileNumber"
//                         value={editForm.mobileNumber || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                         placeholder="Mobile Number"
//                       />
//                     ) : (
//                       conductor.mobileNumber || 'N/A'
//                     )}
//                   </td>
//                   <td>
//                     {conductor.busOwner?.name || 'N/A'}
//                   </td>
//                   <td>
//                     {conductor.assignedBus ? (
//                       <div className="bus-info">
//                         <div><strong>{conductor.assignedBus.busNumber}</strong></div>
//                         <small>{conductor.assignedBus.busName}</small>
//                       </div>
//                     ) : 'Not Assigned'}
//                   </td>
//                   <td>
//                     {!conductor.isPending && editingConductor === conductor.id ? (
//                       <label className="checkbox-label">
//                         <input
//                           type="checkbox"
//                           name="isActive"
//                           checked={editForm.isActive || false}
//                           onChange={handleInputChange}
//                         />
//                         <span className="checkbox-text">
//                           {editForm.isActive ? 'Active' : 'Inactive'}
//                         </span>
//                       </label>
//                     ) : (
//                       <span className={`status-badge ${conductor.isPending ? 'pending' : conductor.status?.toLowerCase() || 'inactive'}`}>
//                         {conductor.isPending ? 'Pending Approval' : conductor.status || 'Inactive'}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     {!conductor.isPending ? (
//                       editingConductor === conductor.id ? (
//                         <div className="edit-actions">
//                           <button className="action-btn save" onClick={handleSaveEdit} disabled={isFetchingDetails}>
//                             {isFetchingDetails ? 'Saving...' : 'Save'}
//                           </button>
//                           <button className="action-btn cancel" onClick={handleCancelEdit} disabled={isFetchingDetails}>
//                             Cancel
//                           </button>
//                         </div>
//                       ) : (
//                         <div className="action-buttons">
//                           <button
//                             className="action-btn view"
//                             onClick={() => handleViewConductor(conductor)}
//                             disabled={isFetchingDetails}
//                           >
//                             {isFetchingDetails ? 'Loading...' : 'View'}
//                           </button>
//                           <button
//                             className="action-btn edit"
//                             onClick={() => handleEditConductor(conductor.id)}
//                             disabled={isFetchingDetails}
//                             style={{ backgroundColor: '#6f42c1', color: 'white' }}
//                           >
//                             {isFetchingDetails ? 'Loading...' : 'Edit'}
//                           </button>
//                         </div>
//                       )
//                     ) : (
//                       <div className="action-buttons">
//                         <button
//                           className="action-btn view"
//                           onClick={() => handleViewConductor(conductor)}
//                           style={{ backgroundColor: '#17a2b8' }}
//                         >
//                           View
//                         </button>
//                         <button
//                           className="action-btn edit"
//                           onClick={() => handleEditPendingConductor(conductor.id)}
//                           disabled={isFetchingDetails}
//                           style={{ backgroundColor: '#6f42c1', color: 'white' }}
//                         >
//                           {isFetchingDetails ? 'Loading...' : 'Edit'}
//                         </button>
//                         <button
//                           className="action-btn approve"
//                           onClick={() => handleApprovePendingConductor(conductor.id)}
//                           style={{ backgroundColor: '#28a745' }}
//                         >
//                           Approve
//                         </button>
//                         <button
//                           className="action-btn reject"
//                           onClick={() => handleRejectPendingConductor(conductor.id)}
//                           style={{ backgroundColor: '#dc3545' }}
//                         >
//                           Reject
//                         </button>
//                         {conductor.submittedByName && (
//                           <div style={{
//                             fontSize: '10px',
//                             color: '#666',
//                             marginTop: '4px',
//                             display: 'block'
//                           }}>
//                             By: {conductor.submittedByName}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="7" className="no-data">
//                   <p>
//                     {viewMode === 'regular'
//                       ? `No conductors found ${searchTerm ? 'matching your search' : ''}.`
//                       : 'No pending conductors from executive submissions.'}
//                   </p>
//                   {searchTerm && (
//                     <button className="clear-filters-link" onClick={handleRefresh}>
//                       Clear search to see all conductors
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {viewMode === 'regular' && (
//         <div className="pagination-container">
//           <div className="pagination-info">
//             Showing {conductors.length} of {totalConductors} conductors
//             (Page {currentPage} of {totalPages})
//             {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="pagination-btn"
//               onClick={handlePrevPage}
//               disabled={currentPage === 1}
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let pageNumber;
//                 if (totalPages <= 5) {
//                   pageNumber = i + 1;
//                 } else if (currentPage <= 3) {
//                   pageNumber = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   pageNumber = totalPages - 4 + i;
//                 } else {
//                   pageNumber = currentPage - 2 + i;
//                 }

//                 return (
//                   <button
//                     key={pageNumber}
//                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                     onClick={() => handlePageClick(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 );
//               })}
//             </div>

//             <button
//               className="pagination-btn"
//               onClick={handleNextPage}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       {viewingConductor && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Conductor Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="profile-image-section">
//                   <img
//                     src={viewingConductor.profileImage ? 
//                       `${process.env.REACT_APP_BASE_URL}/uploads/${viewingConductor.profileImage}` : 
//                       '/default-profile.png'}
//                     alt={viewingConductor.name || 'Conductor'}
//                     className="profile-image-large"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = '/default-profile.png';
//                     }}
//                   />
//                 </div>
                
//                 <div className="details-grid">
//                   <div className="detail-section">
//                     <h4>Name:</h4>
//                     <p>{viewingConductor.name || 'N/A'}</p>
//                   </div>
                  
//                   <div className="detail-section">
//                     <h4>Mobile Number:</h4>
//                     <p>{viewingConductor.mobileNumber || 'N/A'}</p>
//                   </div>
                  
//                   <div className="detail-section">
//                     <h4>Status:</h4>
//                     <span className={`status-badge ${viewingConductor.isActive ? 'active' : 'inactive'}`}>
//                       {viewingConductor.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
                  
//                   {viewingConductor.busOwner && (
//                     <div className="detail-section full-width">
//                       <h4>Bus Owner:</h4>
//                       <div className="bus-owner-details">
//                         <p><strong>Name:</strong> {viewingConductor.busOwner.name}</p>
//                         <p><strong>Phone:</strong> {viewingConductor.busOwner.phone}</p>
//                       </div>
//                     </div>
//                   )}
                  
//                   {viewingConductor.assignedBus && (
//                     <div className="detail-section full-width">
//                       <h4>Assigned Bus:</h4>
//                       <div className="bus-details">
//                         <p><strong>Bus Number:</strong> {viewingConductor.assignedBus.busNumber}</p>
//                         <p><strong>Bus Name:</strong> {viewingConductor.assignedBus.busName}</p>
//                       </div>
//                     </div>
//                   )}
                  
//                   <div className="detail-section">
//                     <h4>Joined Date:</h4>
//                     <p>{viewingConductor.createdAt}</p>
//                   </div>
                  
//                   <div className="detail-section">
//                     <h4>Last Updated:</h4>
//                     <p>{viewingConductor.updatedAt}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {viewingConductor && isFetchingDetails && <SkeletonModal />}

//       {editingConductor && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={handleCancelEdit}>
//           <div className="modal-content1 edit-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{isEditingPending ? 'Edit Pending Conductor' : 'Edit Conductor'}</h3>
//               <button className="modal-close-btn" onClick={handleCancelEdit}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="edit-form">
//                 <div className="form-group">
//                   <label>Name:</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={editForm.name || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Conductor Name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Mobile Number:</label>
//                   <input
//                     type="text"
//                     name="mobileNumber"
//                     value={editForm.mobileNumber || ''}
//                     onChange={handleInputChange}
//                     className="form-control"
//                     placeholder="Mobile Number"
//                   />
//                 </div>
//                 {!isEditingPending && (
//                   <div className="form-group checkbox-group">
//                     <label className="checkbox-label">
//                       <input
//                         type="checkbox"
//                         name="isActive"
//                         checked={editForm.isActive || false}
//                         onChange={handleInputChange}
//                       />
//                       <span className="checkbox-text">Active Conductor</span>
//                     </label>
//                   </div>
//                 )}
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={handleCancelEdit}>
//                 Cancel
//               </button>
//               <button className="action-btn save" onClick={handleSaveEdit}>
//                 Save Changes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {editingConductor && isFetchingDetails && <SkeletonEditModal />}
//     </div>
//   );
// };

// export default ConductorManagement;

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/ConductorManage.css';      // conductor-only additions (load LAST)
import {
  getConductors,
  getConductorById,
  updateConductor,
  getPendingConductors,
  approvePendingConductor,
  rejectPendingConductor,
  getPendingConductorById,
  updatePendingConductor
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const imgUrl = (p) => (p ? `${process.env.REACT_APP_BASE_URL}/uploads/${p}` : '');

// ============================================================
// Conductor card
// ============================================================
const ConductorCard = ({ c, index, onView, onEdit, onApprove, onReject }) => (
  <div className={`prm-card cm-card ${c.isPending ? 'pending' : ''}`} style={{ animationDelay: `${index * 70}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={c.name} src={imgUrl(c.profileImage)} size={52} />
        <div>
          <div className="prm-card-no">Conductor #{String(c.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{c.name || 'N/A'}</h3>
          <div className="prm-card-sub"><Icon name="calendar" size={14} /> Joined {c.joined}</div>
        </div>
      </div>
      <span className={`prm-status ${c.isPending ? 'pending' : c.isActive ? 'active' : 'inactive'}`}>
        {c.isPending ? 'Pending' : c.status}
      </span>
    </div>
    <div className="pbo-contact">
      <div><Icon name="phone" size={14} /> {c.mobileNumber || 'N/A'}</div>
      <div><Icon name="users" size={14} /> Owner: {c.busOwner?.name || 'N/A'}</div>
    </div>
    <div className="prm-metrics">
      <div className="prm-metric"><div className="v"><Icon name="bus" size={15} /> {c.assignedBus?.busNumber || '—'}</div><div className="l">Assigned Bus</div></div>
      <div className="prm-metric"><div className="v"><Icon name="clock" size={15} /> {c.isPending ? 'Pending' : c.status}</div><div className="l">Status</div></div>
      <div className="prm-metric"><div className="v"><Icon name="calendar" size={15} /> {c.joined}</div><div className="l">Joined</div></div>
    </div>
    {c.isPending && c.submittedByName && (
      <div className="cm-submitted-by">Submitted by: {c.submittedByName}</div>
    )}
    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(c)}><Icon name="eye" size={14} /> View</button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(c)}><Icon name="edit" size={14} /> Edit</button>
      {c.isPending && (
        <>
          <button className="prm-btn primary sm" onClick={() => onApprove(c.id)}><Icon name="check" size={14} /> Approve</button>
          <button className="prm-btn danger sm" onClick={() => onReject(c.id)}><Icon name="x" size={14} /> Reject</button>
        </>
      )}
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const ConductorManagement = () => {
  const { token } = useSelector(state => state.user);

  const [conductors, setConductors] = useState([]);
  const [pendingConductors, setPendingConductors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPending, setLoadingPending] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [layout, setLayout] = useState('table');
  const [viewMode, setViewMode] = useState('regular');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalConductors, setTotalConductors] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalConductors / pageSize));

  const [viewingConductor, setViewingConductor] = useState(null);
  const [editingConductor, setEditingConductor] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [isEditingPending, setIsEditingPending] = useState(false);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);

  const searchTimeoutRef = useRef(null);

  // ---------- debounce search ----------
  useEffect(() => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => { if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current); };
  }, [searchTerm]);

  // ---------- fetch regular conductors ----------
  useEffect(() => {
    if (viewMode !== 'regular') return;
    fetchConductors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, debouncedSearchTerm, viewMode]);

  // ---------- fetch pending conductors ----------
  useEffect(() => {
    if (viewMode !== 'pending') return;
    fetchPendingConductors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode]);

  const fetchConductors = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getConductors(token, currentPage, pageSize, debouncedSearchTerm);
      if (response && response.conductors) {
        setConductors(response.conductors.map((conductor, index) => ({
          id: conductor._id,
          serialNo: (currentPage - 1) * pageSize + index + 1,
          profileImage: conductor.profileImage,
          name: conductor.name || '',
          mobileNumber: conductor.mobileNumber || '',
          assignedBus: conductor.assignedBus || null,
          busOwner: conductor.busOwner || null,
          isActive: conductor.isActive || false,
          joined: formatDateDMY(conductor.createdAt),
          status: conductor.isActive ? 'Active' : 'Inactive',
          isPending: false,
          source: 'regular'
        })));
        setTotalConductors(response.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch conductors.');
      console.error('Error fetching conductors:', err);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  const fetchPendingConductors = async () => {
    try {
      setLoadingPending(true);
      setError(null);
      const response = await getPendingConductors(token);
      if (response && response.success) {
        setPendingConductors(response.data.map((conductor, index) => ({
          id: conductor._id,
          pendingId: conductor._id,
          serialNo: index + 1,
          profileImage: conductor.profileImage || '',
          name: conductor.name || '',
          mobileNumber: conductor.mobileNumber || '',
          assignedBus: conductor.assignedBus || null,
          busOwner: conductor.busOwner || null,
          isActive: false,
          joined: formatDateDMY(conductor.createdAt),
          status: 'Pending',
          isPending: true,
          source: 'pending',
          submittedBy: conductor.submittedBy,
          submittedByName: conductor.submittedByName,
          submittedByEmail: conductor.submittedByEmail,
          operationType: conductor.operationType,
          approvalStatus: conductor.approvalStatus,
          originalData: conductor.originalData
        })));
        setTotalConductors(response.data.length);
      } else {
        setPendingConductors([]);
        setTotalConductors(0);
      }
    } catch (err) {
      console.error('Error fetching pending conductors:', err);
      setError('Failed to fetch pending conductors. Please try again.');
      setPendingConductors([]);
    } finally {
      setLoadingPending(false);
      setFirstLoad(false);
    }
  };

  // keep the page valid if the total shrinks
  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const currentConductors = viewMode === 'regular' ? conductors : pendingConductors;
  const isLoading = viewMode === 'regular' ? loading : loadingPending;

  const visible = useMemo(() => currentConductors.filter(c =>
    statusFilter === 'all' ? true :
    statusFilter === 'active' ? c.status === 'Active' :
    statusFilter === 'pending' ? c.isPending :
    c.status !== 'Active'
  ), [currentConductors, statusFilter]);

  const activeOnPage = currentConductors.filter(c => c.status === 'Active').length;
  const assignedOnPage = currentConductors.filter(c => c.assignedBus).length;

  // ---------- handlers ----------
  const handleExportCSV = () => {
    if (currentConductors.length === 0) return toast.warning('No data to export');
    const headers = ['Serial No.', 'ID', 'Name', 'Mobile', 'Bus Owner', 'Assigned Bus', 'Status', 'Joined'];
    const rows = currentConductors.map(c => [
      c.serialNo, c.id, c.name, c.mobileNumber,
      c.busOwner?.name || 'N/A', c.assignedBus?.busNumber || 'N/A', c.status, c.joined
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `conductors-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  const handleViewConductor = async (conductor) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      const response = conductor.isPending
        ? await getPendingConductorById(conductor.id, token)
        : await getConductorById(conductor.id, token);

      if (response.success) {
        const c = response.data;
        setViewingConductor({
          id: c._id,
          name: c.name || '',
          mobileNumber: c.mobileNumber || '',
          isActive: c.isActive,
          assignedBus: c.assignedBus || null,
          busOwner: c.busOwner || null,
          profileImage: c.profileImage,
          joined: formatDateDMY(c.createdAt),
          updatedAt: formatDateDMY(c.updatedAt),
          isPending: conductor.isPending,
          submittedBy: c.submittedBy,
          submittedByName: c.submittedByName,
          operationType: c.operationType
        });
      } else {
        setError('Failed to fetch conductor details.');
      }
    } catch (err) {
      console.error('Error fetching conductor details:', err);
      setError('Failed to fetch conductor details.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const openEdit = async (conductor) => {
    try {
      setIsFetchingDetails(true);
      setError(null);
      setIsEditingPending(conductor.isPending);

      const response = conductor.isPending
        ? await getPendingConductorById(conductor.id, token)
        : await getConductorById(conductor.id, token);

      if (response.success) {
        const c = response.data;
        setEditingConductor(c._id);
        setEditForm({
          name: c.name || '',
          mobileNumber: c.mobileNumber || '',
          isActive: c.isActive || false
        });
      } else {
        setError('Failed to fetch conductor details for editing.');
      }
    } catch (err) {
      console.error('Error fetching conductor details for editing:', err);
      setError('Failed to fetch conductor details for editing.');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const handleSaveEdit = async () => {
    if (!editForm.name?.trim()) return toast.error('Name is required');
    try {
      setSaving(true);
      const updateData = {
        name: editForm.name,
        mobileNumber: editForm.mobileNumber,
        ...(isEditingPending ? {} : { isActive: editForm.isActive })
      };

      const response = isEditingPending
        ? await updatePendingConductor(editingConductor, updateData, token)
        : await updateConductor(editingConductor, updateData, token);

      if (response.success) {
        if (isEditingPending) {
          setPendingConductors(prev => prev.map(c => c.id === editingConductor ? {
            ...c,
            name: response.data.name,
            mobileNumber: response.data.mobileNumber
          } : c));
        } else {
          setConductors(prev => prev.map(c => c.id === editingConductor ? {
            ...c,
            name: response.data.name,
            mobileNumber: response.data.mobileNumber,
            status: response.data.isActive ? 'Active' : 'Inactive',
            isActive: response.data.isActive
          } : c));
        }
        toast.success(isEditingPending ? 'Pending conductor updated successfully' : 'Conductor updated successfully');
        setEditingConductor(null);
        setEditForm({});
        setIsEditingPending(false);
      } else {
        throw new Error(response.message || 'Failed to update conductor');
      }
    } catch (err) {
      console.error('Error updating conductor:', err);
      toast.error('Failed to update conductor. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleApprovePendingConductor = async (pendingId) => {
    try {
      setError(null);
      const response = await approvePendingConductor(pendingId, token);
      if (response.success) {
        toast.success('Pending conductor approved successfully!');
        setPendingConductors(prev => prev.filter(c => c.id !== pendingId));
        setTotalConductors(prev => prev - 1);
        await fetchConductors();
      } else {
        throw new Error(response.message || 'Failed to approve pending conductor');
      }
    } catch (err) {
      console.error('Error approving pending conductor:', err);
      setError('Failed to approve pending conductor. Please try again.');
      toast.error('Failed to approve pending conductor. Please try again.');
    }
  };

  const handleRejectPendingConductor = async (pendingId) => {
    if (!window.confirm('Are you sure you want to reject this pending conductor?')) return;
    try {
      setError(null);
      const response = await rejectPendingConductor(pendingId, token);
      if (response.success) {
        toast.success('Pending conductor rejected successfully!');
        setPendingConductors(prev => prev.filter(c => c.id !== pendingId));
        setTotalConductors(prev => prev - 1);
      } else {
        throw new Error(response.message || 'Failed to reject pending conductor');
      }
    } catch (err) {
      console.error('Error rejecting pending conductor:', err);
      setError('Failed to reject pending conductor. Please try again.');
      toast.error('Failed to reject pending conductor. Please try again.');
    }
  };

  const handleRefresh = () => {
    setSearchTerm(''); setDebouncedSearchTerm(''); setStatusFilter('all'); setCurrentPage(1);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (viewMode === 'regular') fetchConductors();
    else fetchPendingConductors();
  };

  // ============================================================
  if (firstLoad && isLoading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Conductors</span>
          <h1>Conductor Management</h1><p>Loading conductors…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Conductor Insights</span>
          <h1>Conductor Management</h1>
          <p>Browse registered conductors, review their assignments and manage pending approvals.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by name, mobile or bus owner…" value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setDebouncedSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleExportCSV}>
            <span className="plus"><Icon name="download" size={14} /></span> Export CSV
          </button>
        </div>
      </div>

      {error && <div className="cm-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={handleRefresh}>Retry</button></div>}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="users" tone="indigo" label={viewMode === 'regular' ? 'Total Conductors' : 'Pending Conductors'} value={totalConductors || currentConductors.length} hint={viewMode === 'regular' ? 'All registered conductors' : 'Awaiting approval'} delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
        <StatCard icon="bus" tone="amber" label="With Assigned Bus" value={assignedOnPage} hint="Conductors with bus assignment" delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={currentConductors.length} hint="Conductors on this page" delay={320} />
      </div>

      {/* TABS */}
      <div className="cm-tabs">
        <button className={`cm-tab ${viewMode === 'regular' ? 'active' : ''}`} onClick={() => { setViewMode('regular'); setCurrentPage(1); setSearchTerm(''); setDebouncedSearchTerm(''); }}>
          <Icon name="users" size={15} /> Regular Conductors
        </button>
        <button className={`cm-tab ${viewMode === 'pending' ? 'active' : ''}`} onClick={() => { setViewMode('pending'); setCurrentPage(1); setSearchTerm(''); setDebouncedSearchTerm(''); }}>
          <Icon name="clock" size={15} /> Executive Submitted
          {pendingConductors.length > 0 && <span className="cm-badge">{pendingConductors.length}</span>}
        </button>
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {[['all', 'All', currentConductors.length], ['active', 'Active', activeOnPage], ['inactive', 'Inactive', currentConductors.length - activeOnPage]].map(([k, l, c]) => (
              <button key={k} className={`prm-chip ${statusFilter === k ? 'active' : ''}`} onClick={() => setStatusFilter(k)}>
                {l} <span className="count">{c}</span>
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: "{searchTerm}"</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{visible.length}</b> of {totalConductors}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={isLoading ? 'cm-loading' : ''}>
        {visible.length === 0 && !isLoading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'users'} size={44} /></div>
            <h3>{searchTerm || statusFilter !== 'all' ? 'No conductors match your search' : viewMode === 'pending' ? 'No pending conductors' : 'No conductors yet'}</h3>
            <p>{searchTerm || statusFilter !== 'all' ? 'Try a different search term or clear the filters.' : viewMode === 'pending' ? 'Executive-submitted conductors will appear here.' : 'Registered conductors will appear here.'}</p>
            {(searchTerm || statusFilter !== 'all') && <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {visible.map((c, i) => <ConductorCard key={c.id} c={c} index={i} onView={handleViewConductor} onEdit={openEdit} onApprove={handleApprovePendingConductor} onReject={handleRejectPendingConductor} />)}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr><th>No.</th><th>Conductor</th><th>Mobile</th><th>Bus Owner</th><th>Assigned Bus</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {visible.map((c, i) => (
                  <tr key={c.id} className={c.isPending ? 'cm-pending-row' : ''} style={{ animationDelay: `${i * 50}ms` }}>
                    <td>{c.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={c.name} src={imgUrl(c.profileImage)} />
                        <div>
                          <div className="name">{c.name || 'N/A'}</div>
                          {c.isPending && c.submittedByName && <div className="sub">By: {c.submittedByName}</div>}
                        </div>
                      </div>
                    </td>
                    <td>{c.mobileNumber || 'N/A'}</td>
                    <td>{c.busOwner?.name || 'N/A'}</td>
                    <td>{c.assignedBus ? <><b>{c.assignedBus.busNumber}</b><br /><small>{c.assignedBus.busName}</small></> : 'Not Assigned'}</td>
                    <td><span className={`prm-status ${c.isPending ? 'pending' : c.isActive ? 'active' : 'inactive'}`}>{c.isPending ? 'Pending' : c.status}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewConductor(c)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => openEdit(c)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                        {c.isPending && (
                          <>
                            <button className="prm-btn primary sm icon-only" onClick={() => handleApprovePendingConductor(c.id)} title="Approve" aria-label="Approve"><Icon name="check" size={14} /></button>
                            <button className="prm-btn danger sm icon-only" onClick={() => handleRejectPendingConductor(c.id)} title="Reject" aria-label="Reject"><Icon name="x" size={14} /></button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION — always visible */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalConductors}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="conductors"
      />

      {/* EDIT MODAL */}
      {editingConductor && !isFetchingDetails && (
        <div className="prm-overlay" onClick={() => { setEditingConductor(null); setEditForm({}); setIsEditingPending(false); }}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>{isEditingPending ? 'Edit pending conductor' : 'Edit conductor'}</h3><p>{editForm.mobileNumber || editForm.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => { setEditingConductor(null); setEditForm({}); setIsEditingPending(false); }}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Name" required><input className="prm-input" value={editForm.name || ''} onChange={(e) => setEditForm(p => ({ ...p, name: e.target.value }))} /></Field>
                <Field label="Mobile Number"><input className="prm-input" value={editForm.mobileNumber || ''} onChange={(e) => setEditForm(p => ({ ...p, mobileNumber: e.target.value }))} /></Field>
                {!isEditingPending && (
                  <Field label="Status">
                    <label className="cm-toggle">
                      <input type="checkbox" checked={editForm.isActive || false} onChange={(e) => setEditForm(p => ({ ...p, isActive: e.target.checked }))} />
                      <span>{editForm.isActive ? 'Active' : 'Inactive'}</span>
                    </label>
                  </Field>
                )}
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { setEditingConductor(null); setEditForm({}); setIsEditingPending(false); }}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit} disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewingConductor && !isFetchingDetails && (
        <div className="prm-overlay" onClick={() => setViewingConductor(null)}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingConductor.name} src={imgUrl(viewingConductor.profileImage)} size={52} />
                <div>
                  <h3>{viewingConductor.name || 'Conductor'}</h3>
                  <p>{viewingConductor.mobileNumber || 'N/A'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingConductor(null)}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b className={viewingConductor.isPending ? 'cm-status-pending' : viewingConductor.isActive ? 'cm-ok' : 'cm-off'}>{viewingConductor.isPending ? 'Pending' : viewingConductor.isActive ? 'Active' : 'Inactive'}</b></div>
                <div><span>Joined</span><b>{viewingConductor.joined}</b></div>
                <div><span>Bus Owner</span><b>{viewingConductor.busOwner?.name || 'N/A'}</b></div>
                <div><span>Assigned Bus</span><b>{viewingConductor.assignedBus?.busNumber || 'Not Assigned'}</b></div>
              </div>

              <div className="prm-section-title">Assignment details</div>

              <div className="cm-conductor-grid" style={{ marginTop: 8 }}>
                <div>
                  <small>Bus Owner</small>
                  {viewingConductor.busOwner ? (
                    <><b>{viewingConductor.busOwner.name}</b><span>{viewingConductor.busOwner.phone}</span></>
                  ) : <b>N/A</b>}
                </div>
                <div>
                  <small>Assigned Bus</small>
                  {viewingConductor.assignedBus ? (
                    <><b>{viewingConductor.assignedBus.busNumber}</b><span>{viewingConductor.assignedBus.busName}</span></>
                  ) : <b>Not Assigned</b>}
                </div>
                <div>
                  <small>Last Updated</small>
                  <b>{viewingConductor.updatedAt}</b>
                </div>
              </div>

              {viewingConductor.isPending && viewingConductor.submittedByName && (
                <div style={{ marginTop: 16, padding: '10px 14px', background: '#fffbeb', borderRadius: 10, border: '1px solid #fde68a', fontSize: 13, color: '#92400e' }}>
                  <Icon name="info" size={14} /> Submitted by: <b>{viewingConductor.submittedByName}</b> · Operation: {viewingConductor.operationType || 'N/A'}
                </div>
              )}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { const c = viewingConductor; setViewingConductor(null); openEdit(c); }}><Icon name="edit" size={15} /> Edit</button>
                <button className="prm-btn primary" onClick={() => setViewingConductor(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* LOADING SKELETON FOR DETAILS */}
      {isFetchingDetails && (
        <div className="prm-overlay">
          <div className="prm-form-modal prm-form-modal-sm">
            <div className="prm-skel" style={{ padding: 40 }}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConductorManagement;